export class B2CUserToken {
  static IB2CUserRepository = Symbol("IB2CUserRepository");
  static B2CUserManagementUseCase = Symbol("B2CUserManagementUseCase");
  static StaffManagementViewModel = Symbol("StaffManagementViewModel");
  static StoreManagerViewModel = Symbol("StoreManagerViewModel");
  static UserChainManagementViewModel = Symbol("UserChainManagementViewModel");
}
